import { StandardDropdown, StandardDropdownProps, BrandfolderHexColors } from '@brandfolder/react';
import { FunctionComponent } from 'react';
import styled from 'styled-components';

interface HeaderDropdownProps extends StandardDropdownProps {}

const UnstyledHeaderDropdown: FunctionComponent<HeaderDropdownProps> = (props) => {
  return <StandardDropdown {...props} />;
};

const StyledHeaderDropdown = styled(UnstyledHeaderDropdown)`
  max-width: 100%;

  .bf-button__standard {
    border-radius: 0;
    height: 78px;
    min-height: 0;
    padding: 0 16px;
    width: 100%;

    &:hover {
      background-color: ${BrandfolderHexColors.White};
      border-bottom-color: ${BrandfolderHexColors.Gray};
      border-bottom-width: 2px;
    }

    &:focus-visible {
      background-color: ${BrandfolderHexColors.White};
      border-bottom-color: ${BrandfolderHexColors.GrayBorder};
    }

    &[aria-expanded='true'] {
      background-color: ${BrandfolderHexColors.DirtyMarshmallow};
      border-bottom-color: transparent;
    }

    .bf-button__standard__children {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: block;
    }

    .bf-button__standard__start-icon {
      font-size: 14px;
    }
  }
`;

export const HeaderDropdown: FunctionComponent<HeaderDropdownProps> = (props) => {
  return <StyledHeaderDropdown {...props} />;
};
